import * as React from 'react'
import { SearchForm } from '../MediaUploadPrompt/SearchForm'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import Styles from '../Prompt.module.scss'
import { JiraIssue } from 'common/Prose/nodeViews/JiraEmbed/JiraIssue'
import { GenericEmbed, SetState } from 'types'
import { JIRA_INTEGRATION_REGEX } from 'screens/ProseEdit/utils'

export const JiraPreview = ({
  inputRef,
  inputValue,
  setInputValue,
  issueId,
  setStagedEmbed,
  onSuccess,
}: {
  inputRef: React.RefObject<HTMLInputElement>
  inputValue: string
  setInputValue: React.Dispatch<React.SetStateAction<string>>
  issueId: string
  setStagedEmbed: SetState<GenericEmbed | undefined>
  onSuccess: () => void
}) => {
  const queryClient = new QueryClient()

  const validUrl = (value: string) => {
    const regexResult = JIRA_INTEGRATION_REGEX.exec(value)

    return !!regexResult
  }

  return (
    <div>
      <SearchForm
        inputRef={inputRef}
        placeholder="https://subdomain.atlassian.com/browse/SCRUM-1"
        query={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setInputValue(e.target.value)

          if (!validUrl(e.target.value)) {
            setStagedEmbed(undefined)
          }
        }}
        onSubmit={(e) => {
          e?.preventDefault()

          if (validUrl(inputValue)) {
            onSuccess()
          }
        }}
        clearQuery={() => {
          setInputValue('')
          setStagedEmbed(undefined)
        }}
      />

      <div className={Styles.previewContainer}>
        <Router>
          <QueryClientProvider client={queryClient}>
            <JiraIssue preview node={{ attrs: { type: 'issue', link: inputValue, issueId, mode: 'frame' } } as any} />
          </QueryClientProvider>
        </Router>
      </div>
    </div>
  )
}
